import React, { useEffect, useState } from 'react';
import { ReadyState } from '../AppWebSocket/AppWebSocket';

const GRACE_MS = 5000; // não pisca em desconexões rápidas

/**
 * Banner fixo no topo da tela mostrando estado da conexão com o backend.
 * Só aparece quando o WS fica desconectado por mais de GRACE_MS — assim
 * reconexões rápidas (típicas em deploy ou reload) não geram ruído visual.
 *
 * props:
 * - readyState: ReadyState do react-use-websocket
 */
function ConnectionBanner({ readyState }) {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (readyState === ReadyState.OPEN) {
            setVisible(false);
            return undefined;
        }
        const t = setTimeout(() => setVisible(true), GRACE_MS);
        return () => clearTimeout(t);
    }, [readyState]);

    if (!visible) return null;

    const label = readyState === ReadyState.CONNECTING
        ? 'Conectando ao servidor...'
        : 'Conexão com o servidor perdida — tentando reconectar...';

    return (
        <div
            role='alert'
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                zIndex: 1100,
                background: '#dc3545',
                color: '#fff',
                padding: '6px 12px',
                fontSize: 13,
                textAlign: 'center',
                boxShadow: '0 2px 6px rgba(0,0,0,0.15)'
            }}
        >
            <span className='spinner-border spinner-border-sm me-2' role='status' aria-hidden='true' />
            {label}
            <small className='ms-2 opacity-75'>
                Se isso persistir, sua sessão pode ter expirado — recarregue a página.
            </small>
        </div>
    );
}

export default ConnectionBanner;
